import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "holdings-container" }

import { onUnmounted } from 'vue';
import Assets from '@/components/holdings/Assets.vue'
import AssetsDetail from '@/components/holdings/AssetsDetail.vue'
import { HoldingsMutationTypes } from '@/store/modules/holdings/mutations-type';
import { useStore } from 'vuex';


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const store = useStore()

onUnmounted(() => {
  store.commit(HoldingsMutationTypes.RESET_STATE)
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Assets),
    _createVNode(AssetsDetail)
  ]))
}
}

})